import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

import Token from '@/services/token';

Vue.use(VueAxios, axios);

const API = {
    init() {
        Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    },

    setHeader() {
        Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${Token.getToken()}`;
    },

    query(resource, params) {
        return Vue.axios.get(resource, params);
    },

    download(resource, params) {
        return Vue.axios.get(resource, {
            ...params,
            responseType: "blob"
        });
    },

    get(resource, slug = '') {
        return Vue.axios.get(`${resource}/${slug}`);
    },

    post(resource, params) {
        return Vue.axios.post(`${resource}`, params)
    },

    update(resource, slug, params) {
        return Vue.axios.put(`${resource}/${slug}`, params)
    },

    put(resource, params) {
        return Vue.axios.put(`${resource}`, params)
    },

    delete(resource) {
        return Vue.axios.delete(resource);
    }
};

export default API;
